import { UPDATE_DIALOG_CUSTOMER } from 'store/definitions/dialogs';

export function updateDialog(action) {
  const { mode, open, currentCustomer } = action;
  return {
    type: UPDATE_DIALOG_CUSTOMER,
    payload: { mode, open, currentCustomer },
  };
}
